














import Vue, { PropOptions } from 'vue'; // eslint-disable-line

export default Vue.extend({
  name: 'selectBox',
  props: {
    name: String,
    initialValue: {
      type: [Number, String],
      default: 0,
    },
    // selectValue: Number,
    options: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: {} as Number | String,
    };
  },
  mounted() {
    let value = this.initialValue;
    // // 初期値がない場合
    // if (value === 0 && this.options.length >= 0) {
    //   value = (this as any).options[0].value; // eslint-disable-line
    // }
    this.selectValue = value;
  },
  watch: {
    selectValue() {
      this.$emit('change', this.selectValue);
    },
    initialValue() {
      this.selectValue = this.initialValue;
    },
  },
});
